
// Load Bootstrap init
import { initBootstrap } from "../helpers/bootstrap";
import { breadcrumbExpander } from "../helpers/common";
import { artDropdownSelect } from "../helpers/common";
import {watchNavbarScroll, watchNavbarSearch, watchSearchFocus, dropdownToggleClicked, dropdownToggleHover} from '../helpers/header';
import { monitorDismissibleAlerts } from '../helpers/alerts';
import { monitorModalYoutubeVideos } from "../helpers/modals";

// Loading bootstrap with optional features
initBootstrap({
    tooltip: true,
    popover: true,        
    dropdown: true,
    offcanvas: true,
    dropdown: true,
    collapse: true,
    alert: true,
    tab: true,    
});

// setup events
(() => {
  
  breadcrumbExpander();
  artDropdownSelect();
  monitorDismissibleAlerts();
  watchNavbarScroll();
  watchNavbarSearch();
  watchSearchFocus();
  dropdownToggleClicked();
  dropdownToggleHover();
  monitorModalYoutubeVideos();

})();
